import { render, staticRenderFns } from "./switch.component.vue?vue&type=template&id=e5f7313a&scoped=true&"
import script from "./switch.component.vue?vue&type=script&lang=ts&"
export * from "./switch.component.vue?vue&type=script&lang=ts&"
import style0 from "./switch.component.vue?vue&type=style&index=0&id=e5f7313a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f7313a",
  null
  
)

export default component.exports